import React, { useEffect } from 'react';
import styles from 'new/components/collaborate/user/UserDetail.module.scss';
import { useSelector } from 'react-redux';
import { ResourceShare } from 'new/elements/ResourceShare';
import { Subheader } from 'new/elements/Subheader';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_COLLABORATE_USER } from 'new/constants/pathnames';
import { useAppContext } from 'new/hooks/useAppContext';

interface OrgProps {
  match: {
    params: {
      id: string;
    };
  };
}

export const UserDetail: ScreenComponent<any> = (props: OrgProps) => {
  const {
    match: {
      params: { id },
    },
  } = props;
  const user = useSelector((state: any) => state.entities.users[id]);
  const { setHeaderTitle, setCurrentSlug, headerTitle } = useAppContext();

  useEffect(() => {
    if (user?.name) {
      setCurrentSlug(user.name);
      setHeaderTitle(user.name);
    }
  }, [user, headerTitle]);

  if (!user) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Subheader showAvatar title={user.full_name} />
      </div>
      <ResourceShare user={user} />
    </div>
  );
};

UserDetail.screenConfig = {
  screenName: 'UserDetail',
  domain: 'collaborate',
  path: `${ROUTE_REDESIGN}${ROUTE_COLLABORATE_USER}/:id`,
};
